/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { DeleteCompositionsDetailMutationResponse, DeleteCompositionsDetailPathParams, DeleteCompositionsDetail404 } from "../models/DeleteCompositionsDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteCompositionsDetail } from "../axios/deleteCompositionsDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteCompositionsDetailMutationKey = () => ["web-app-bff-api", { url: '/compositions/:id' }] as const

export type DeleteCompositionsDetailMutationKey = ReturnType<typeof deleteCompositionsDetailMutationKey>

export function deleteCompositionsDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteCompositionsDetailMutationKey()
        return mutationOptions<DeleteCompositionsDetailMutationResponse, ResponseErrorConfig<DeleteCompositionsDetail404>, {id: DeleteCompositionsDetailPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return deleteCompositionsDetail(id, config)
          },
        })

}

/**
 * @summary Delete a composition by id
 * {@link /compositions/:id}
 */
export function useDeleteCompositionsDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteCompositionsDetailMutationResponse, ResponseErrorConfig<DeleteCompositionsDetail404>, {id: DeleteCompositionsDetailPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteCompositionsDetailMutationKey()

          const baseOptions = deleteCompositionsDetailMutationOptions(config) as UseMutationOptions<DeleteCompositionsDetailMutationResponse, ResponseErrorConfig<DeleteCompositionsDetail404>, {id: DeleteCompositionsDetailPathParams["id"]}, TContext>
          

          return useMutation<DeleteCompositionsDetailMutationResponse, ResponseErrorConfig<DeleteCompositionsDetail404>, {id: DeleteCompositionsDetailPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteCompositionsDetailMutationResponse, ResponseErrorConfig<DeleteCompositionsDetail404>, {id: DeleteCompositionsDetailPathParams["id"]}, TContext>
      
}